import { NavigateFunction } from 'react-router-dom';

import { AccountResponseDTO, AccountUserDetailDTO, UserDetailDTO } from '_lib/api/apiTypes.shim';

export type AuthUser = UserDetailDTO | AccountUserDetailDTO;

export type LoginResult = {
  user: AuthUser;
};

type AuthTokenNotFoundContext = {
  messageToDisplay: string;
};

export class AuthTokenNotFound extends Error {
  /**
   * The human-friendly error message to display to a user
   */
  messageToDisplay: string;

  constructor(message: string, context: AuthTokenNotFoundContext) {
    super(message);
    this.messageToDisplay = context.messageToDisplay;
  }
}

export type AuthSuccessResult = LoginResult & {
  navigate: NavigateFunction;
};

export type PermissionFunctionArgs = {
  user: AuthUser;
  account?: AccountResponseDTO;
};

export type PermissionFunction = (args: PermissionFunctionArgs) => boolean;
